import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import AppShell from './components/AppShell';
import RulesContent from './components/RulesContent';
import GamePage from './pages/GamePage';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="noise">
      <Routes>
        <Route path="/" element={
          <AppShell>
            <RulesContent />
          </AppShell>
        } />
        <Route path="/game" element={<GamePage />} />
      </Routes>
      <Toaster />
    </div>
  );
}

export default App;
